import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import ListContacts from '../views/ListContacts.vue';
import Account from '../views/Account.vue';
import Performance from '../views/Performance.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'contacts',
    component: ListContacts,
    meta: { requiresAuth: true }
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: { requiresAuth: true }
  },
  {
    path: '/performance',
    name: 'performance',
    component: Performance,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('authToken');
  const requiresAuth =
    to.meta.requiresAuth == undefined || to.meta.requiresAuth;
  if (requiresAuth) {
    console.log('requires login');
    // this route requires auth, check if logged in
    if (!isLoggedIn) {
      console.log('not login');
      // if not, redirect to login page.
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      //is logged
      console.log('is login');
    }
  }
  next();
});

export default router;
